<template>
  <v-container style="margin: 0px; padding: 0px; max-width:100%; vertical-align:top;">
    <v-toolbar color="indigo" dark dense>
      <v-toolbar-title>{{ args.desc }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click.native="close">Close</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="compact-form" style="margin-top:10px;">
      <v-layout row justify-end style="margin-right:20px; vertical-align:top;" class="pl-4">
        <v-col cols="8" class="pl-4"> NOTE: You are entering the harvest weights for all plants of the same strain in the selected room. Once you start entering weights, all the weights must be entered today.
        </v-col>
        <v-col cols="4" align="right">
          <v-btn
            color="blue"
            @click="save"
            >Save</v-btn>
        </v-col>
      </v-layout>
      <v-divider style="margin-top: 10px;"></v-divider>
       <div id="harvestStats" style="margin-top:10px;">
        <v-layout align-center justify-center wrap class="pl-4">
        <v-row>
          <v-col>
            <v-card>
              <v-card-title class="text-h4 pl-4 indigo darken-1 white--text">Harvest Stats</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
            <h3 class="text-h5 pl-4 light-green--text text--accent-3">Net Weight: {{Number(net).toLocaleString()}} {{unit}}</h3>
          </v-col>
                  <v-col cols="12" sm="6">
            <h3 class="text-h5 pl-4">Plant Count: {{Number(plants).toLocaleString()}}</h3>
          </v-col>
          <v-col  cols="12" sm="6">
            <h3 class="text-h5 pl-4">Gross Weight: {{Number(gross).toLocaleString()}} {{unit}}</h3>
          </v-col>
          <v-col  cols="12" sm="6">
            <h3 class="text-h5 pl-4">Totes Used: {{totes.length}}</h3>           
          </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        </v-layout>
        </div>
      <div id="harvestInfo" style="margin-top:10px;">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row no-gutters class="text-h4 pl-4 indigo darken-1">Harvest Setup
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              clearable
              v-model="room"
              label="Source Room"
              outlined
              :items="roomList"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              clearable
              v-model="to_room"
              label="Drying Room"
              outlined
              :items="roomList"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              clearable
              v-model="strain"
              label="Strain in Flower"
              outlined
              :items="strainList"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              clearable
              v-model="unit"
              label="Unit of Measure"
              outlined
              :items="units"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormatted"
              label="Date"
              hint="MM/DD/YYYY format"
              persistent-hint
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              @blur="date = parseDate(dateFormatted)"
              v-on="on"
            ></v-text-field>
        </template>
          <v-date-picker
            v-model="date"
            no-title
            @input="menu1 = false"
          ></v-date-picker>
            </v-menu>
          </v-col>
          </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
        <div id="harvestEntry" style="margin-top:10px;">
          <v-layout align-center justify-center wrap class="pl-4">
        <v-row>
          <v-col>
            <v-card>
              <v-card-title class="text-h4 pl-4 indigo darken-1">Weight Entry</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                  <v-card flat class="d-flex flex-column" height="100%">
                      <v-card-title class="margin-top:-10px;">Enter Empty Tote Weight</v-card-title>
                      <v-card-subtitle>This setting can be set once per harvest or changed for every tote. If no tote was used during harvest, set this value to 0</v-card-subtitle>
                      <v-spacer></v-spacer>
                      <v-card-actions>
                  <v-text-field
              v-model="emptyTote"
              label="Empty Tote Weight"
              clearable
              solo
              outlined
              background-color="#757575"
            ></v-text-field></v-card-actions>
                      </v-card>
                </v-col>
                 <v-col cols="12" sm="6">
                  <v-card flat class="d-flex flex-column" height="100%">
                      <v-card-title>Enter Weight</v-card-title>
                      <v-card-subtitle>Captures the weight of the tote and plant materials. Hit enter to record the weight.</v-card-subtitle>
                      <v-spacer></v-spacer>
                      <v-card-actions>
            <v-text-field
              v-model="newWeight"
              clearable
              outlined
              label="Enter Weight"
              solo
              @keydown.enter="enterWeight"
              background-color="#388E3C"
            >
              <template v-slot:prepend>
                <v-fade-transition>
                  <v-icon v-if="newWeight" @click="enterWeight"
                    >mdi-plus</v-icon
                  >
                </v-fade-transition>
              </template>
            </v-text-field>
                      </v-card-actions>
                  </v-card>
                 </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
          </v-layout>
        </div>
        <div id="harvestDetails" style="margin-top:10px;">
          <v-layout align-center justify-center wrap class="pl-4">
            <v-row>
              <v-col>
            <v-card v-show="totes.length > 0" width="100%" height="100%" style="vertical-align:top;">
              <v-card-title class="text-h4 pl-4 indigo darken-1">Harvest Details</v-card-title>
               <v-divider
                    style="background-color:grey"
                  ></v-divider>
              <v-card-text>
              <v-slide-y-transition class="py-0" group tag="v-list">
                <template v-for="(tote, i) in totes">
                  <v-list-item
                    :key="`${i}-${totes.tote}`"
                    class="px-0 py-0 ma-0"
                    align="top"
                  >
                    <v-card width="100%" flat class="d-flex flex-column">
                      <v-row wrap no-gutters>
                        <v-col cols="12" sm="3">
                      <v-card-title class="text-h5">
                          Tote:<br>{{ tote.i }}
                          </v-card-title>
                            </v-col>
                            <v-col cols="12" sm="3">
                            <v-card-title>Tote Weight:<br>{{Number(tote.tote).toLocaleString()}} {{unit}} (empty)</v-card-title>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-card-title> Gross Weight:<br>{{Number(tote.gross).toLocaleString()}} {{unit}} </v-card-title>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-card-title> Net Weight:<br>{{Number(tote.net).toLocaleString()}} {{unit}} </v-card-title>
                        </v-col>
                        <v-col cols="1" sm="4">
                        <v-card-actions>
                         <v-btn
                              fab
                              x-small
                              rounded
                              color="error"
                              @click="removeWeight(totes, i)"
                              ><v-icon>mdi-trash-can</v-icon></v-btn
                            >
                            </v-card-actions>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-list-item>
                  <v-divider
                    :key="`${i}-divider`"
                    style="background-color:grey"
                  ></v-divider>
                </template>
              </v-slide-y-transition>
              </v-card-text>
            </v-card>
              </v-col>
            </v-row>
          </v-layout>
        </div>
        </div>
  </v-container>
</template>
<script>
import { sync } from "vuex-pathify";
import axiosInstances from "@/../../coreui/server/axiosInstances";
export default {
  props: ["args"],
  data: vm => ({
    // Harvest Calculator
    plants: null,
    room: null,
    to_room: null,
    strain: null,
    roomList: [],
    rawRoomList: [],
    strainList: [],
    rawStrainList: [],
    includeRooms: [],
    includeStrains: [],
    units: ["lb", "oz","g", "kg"],
    unit: null,
    emptyTote: 0,
    totes:[],
    gross: null,
    net: null,
    newWeight: null,
    menu1: false,
    showSettings: true,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
  }),
  computed: {
  },
  watch: {
      emptyTote: { handler(val){
          this.calcWeight()
      }
      },
    cmdDialog(val) {
      val || this.close();
    },
    date(val) {
        this.dateFormatted = this.formatDate(this.date)
    },
    room(val){
      console.log(`Room selected = ${val}`)
      let roomList = this.rawRoomList.filter(x => x.name === val)
      console.log(`Candidate Rooms = ${roomList.length}`)
      let roomIncludes = roomList.map( x => x["_id"])
      this.includeRooms = roomIncludes
      this.fetchPlants()
    },
    strain(val){
      console.log(`Strain Selected = ${val}`)
      let strainList = this.rawStrainList.filter(x => x.name === val)
      let strainIncludes = strainList.map( x => x["_id"])
      this.includeStrains = strainIncludes
      this.fetchPlants()
    }
  },
  methods: {
      async fetchPlants(){
        console.log(`Fetching plant count`)
        let query = [{"$match": {"IsUsed":"yes"}}, {"$match": {"phase": "Flowering"}}]
        if(this.includeRooms.length > 0)
          query.push({"$match": {"room": {"$in": this.includeRooms}}})
        if(this.includeStrains.length > 0)
          query.push({"$match": {"strain": {"$in": this.includeStrains}}})
        query.push({"$count": "plants"})
        
        if(query.length > 3){
          let queryResult = await axiosInstances.apiServer.post(`/misc/dbops?c=cul_plants&op=pipe`, JSON.stringify(query))
          let queryData = queryResult.data
          if(queryData === null) this.plants = 0
          else{
            console.log(`Result = ${JSON.stringify(queryData)}`)
            this.plants = queryData[0].plants
          }
        } else{
          this.plants = 0
        }

      },
      formatDate(date){
          if(!date) return null
          const [year, month, day] = date.split("-")
          return `${month}/${day}/${year}`
      },
      parseDate(date){
          if(!date) return null
          const[month, day, year] = date.split('/')
          return `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`
      },
    calcWeight(){
        this.gross = this.totes.map(item => item.gross).reduce((prev, curr) => parseFloat(prev) + parseFloat(curr), 0)
        this.net = this.totes.map(item => item.net).reduce((prev, curr) => parseFloat(prev) + parseFloat(curr), 0)
    },
    enterWeight() {
        if(this.newWeight === null) return
        if(isNaN(this.newWeight)){ 
          this.newWeight = null
          return
        }
        let newNet = parseFloat(this.newWeight) - parseFloat(this.emptyTote)
        this.totes.unshift({gross: this.newWeight, net: newNet, tote: this.emptyTote})
        this.renumber()
        this.newWeight = null;
        this.calcWeight()
    },
    renumber(){
      let max = this.totes.length
      for(let i = 0; i < this.totes.length; i++){
        this.totes[i].i = max -i
      }
    },
    async removeWeight(item) {
      var self = this;
      this.$root
        .$confirm("Delete", "Are you sure you want to delete this item?", {
          color: "red",
        })
        .then(function(confirm) {
          if (confirm) {
            let index = self.totes.findIndex(
              (x) => x.i === item.i
            );
            self.totes.splice(index, 1);
            self.renumber()
            self.calcWeight()
          }
        });
    },
    close() {
      this.$router.go(-1);
    },
    async save() {
        console.log(`in the save function`)
        var self = this
        // Prepare the payload in case of submission
        let payload = {
            action: "harvest_room_worksheet",
            room: this.room,
            strain: this.strain,
            totes: this.totes,
            bin: this.emptyTote,
            unit: this.unit,
            date: this.date
        }
        // Check that the needed items have been defined
        let roomMissing = this.room === null ? true : false
        let strainMissing = this.strain === null ? true : false
        let unitMissing = this.unit === null ? true : false
        let totesMissing = this.totes.length === 0 ? true : false
        let dateMissing = this.date === null ? true : false
        if(roomMissing || strainMissing || unitMissing || totesMissing || dateMissing){
        let title = "<h3>Missing Harvest Information:</h3><br>"
        let listStart = "<ul>"
        let details = []
        let listEnd = "</ul>"
        if(roomMissing) details.push("<li>Room Selection</li>")
        if(strainMissing) details.push("<li>Strain Selection</li>")
        if(dateMissing) details.push("<li>Harvest Date</li>")
        if(unitMissing) details.push("<li>Unit Selection</li>")
        if(totesMissing) details.push("<li>Harvest Weights</li>")
        let listMsg = listStart
        for(const entry of details) listMsg = `${listMsg}${entry}`
        listMsg = `${listMsg}${listEnd}` 
        let msg = `${title}${listMsg}`
        this.$root.$confirm("ERROR: Data Incomplete", `${msg}`,{
            color:"red",
            html: true,
            width: 400,
            nocancel: true,
            ok: "Ok"
        }).then(function(confirm){
        })
        } else {


        // Prepare the date for the save dialog
        let title = "<h3>Harvest Details:</h3><br>"
        let details = `<table><tr><td>Room:</td><td>&nbsp;</td><td>${self.room}</tr><tr><td>Strain:</td><td>&nbsp;</td><td>${self.strain}</td></tr>`
        let date = `<tr><td>Date:</td><td>&nbsp;</td><td>${self.dateFormatted}</td></tr>`
        let weight = `<tr><td>Net Weight:</td><td>&nbsp;</td><td>${Number(self.net).toLocaleString()} ${self.unit}</td></tr></table>`
        let msg = `${title}${details}${date}${weight}`
        this.$root.$confirm("Submit Harvest", `${msg}`,{
            color:"green",
            html: true,
            width: 400
        }).then(async function(confirm){
            if(confirm){
                console.log(`saving the request`)
                await axiosInstances.apiServer.post("/dt/v1/temp_cultivation", payload);
                self.clear()
            }
        })
        }
    },
    clear() {
        this.emptyTote = 0
        this.strain = null
        this.room = null
        this.unit = null
        this.roomList = []
        this.totes = []
        this.strainList = []
        this.gross = null
        this.net = null
        this.includeRooms = []
        this.includeStrains = []
        this.rawRoomList = []
        this.rawStrainList = []
        this.plants = 0
    },
  },
  async mounted() {
    // Get the modules and bots needed for this module
    let allRooms = await axiosInstances.apiServer.get("/dt/v1/set_rooms")
    let allStrains = await axiosInstances.apiServer.get("/dt/v1/set_strain")
    
    // Filter the room list into a unique list of names
    let roomList = allRooms.data.filter(x => x.IsUsed === "yes")
    let rooms = [... new Set(roomList.map(x => x.name))]
    let sortedRooms = rooms.sort()
    console.log(`Rooms = ${sortedRooms}`)

    // Get the list of all active strains
    let activeStrains = allStrains.data.filter(x => x.IsUsed === "yes")
    let strainWFlower = activeStrains.filter(x => x.count?.flower > 0)
    let strainNames = strainWFlower.map(x => x.name)
    let strainList = strainNames.sort()

    // Set the values for the rest of the component to use
    this.roomList = sortedRooms;
    this.rawRoomList = roomList;
    this.strainList = strainList;
    this.rawStrainList = strainWFlower;
  },
};
</script>
<style lang="css" scoped>
.compact-form {
  transform: scale(0.95);
  transform-origin: top;
}
.card-outter {
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.flexcard {
  display: flex;
  flex-direction: column;
}
.v-text-field >>> label{
    font-size: 1.15em;
    text-transform: capitalize;
}
</style>
